import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { ResourceEditContext } from 'js/components/ResourceEditProvider/ResourceEditContext';
import { RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';
import { CONNECTOR_CODE_SQL_RUNNER } from 'js/constants/connectionCategories';
import { Button } from 'new/elements/Button';
import styles from './EmptySqlAutomationsState.module.scss';

const EmptySqlAutomationsState: React.FC = () => {
  const { setAction } = useContext(ResourceEditContext);

  const handleNewAutomation = () => {
    setAction?.({
      resource: RESOURCE_TYPE_SOURCE,
      type: 'create',
      queryParams: {
        selectedConnection: CONNECTOR_CODE_SQL_RUNNER,
      },
    });
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <div className={styles.title}>You don&apos;t have any SQL automations yet</div>
        <div className={styles.subtitle}>
          Create your first SQL automation to run scheduled SQL and manage data workflows.
        </div>
      </Box>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleNewAutomation}
        data-testid="sql-automations-empty-new-automation"
      >
        New Automation
      </Button>
    </Box>
  );
};

export default EmptySqlAutomationsState;
